import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const stockItemCategoryAPI = {
    create: async (categoryData) => {
        try {
            const { data } = await api.post('/api/stock-item-categories/create/', categoryData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create stock item category error:');
        }
    },
    getAll: async (page, pageSize, searchTerm) => {
        try {
            const { data } = await api.get('/api/stock-item-categories', {
                params: { page, pageSize, searchTerm }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all stock item categories error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/stock-item-categories/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get stock item category by id error:');
        }
    },
    update: async (id, categoryData) => {
        try {
            const { data } = await api.put(`/api/stock-item-categories/update/${id}/`, categoryData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update stock item category error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/stock-item-categories/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete stock item category error:');
        }
    },
    reorder: async (order) => {
        try {
            const { data } = await api.post('/api/stock-item-categories/reorder/', { order });
            return data;
        } catch (error) {
            handleApiError(error, 'Reorder stock item categories error:');
        }
    }
};